import React from 'react'
import { FaHeartbeat, FaBrain, FaBriefcase, FaLeaf } from "react-icons/fa";
import ProgramCard from '../components/ProgramCard';

export default function ProgramSection() {

  const objectives = [
    {
      title: "Health Promotion",
      description:
        "Raising awareness on preventive healthcare, nutrition, and lifestyle changes to reduce disease burden and enhance well-being.",
      icon: <FaHeartbeat />,
    },
    {
      title: "Mental Health & Psychosocial Support",
      description:
        "Providing mental health education, counseling, and community-based support to foster resilience and emotional well-being.",
      icon: <FaBrain />,
    },
    {
      title: "Economic Empowerment",
      description:
        "Equipping communities with skills, entrepreneurship opportunities, and financial literacy to reduce poverty and boost livelihoods.",
      icon: <FaBriefcase />,
    },
    {
      title: "Environmental Health",
      description:
        "Promoting clean environments, climate adaptation, and sustainable practices to protect both human and planetary health.",
      icon: <FaLeaf />,
    },
  ];

  return (
    <div className="mx-auto px-6 bg-secondary bg-opacity-20 py-32 sm:px-10 md:px-20 mt-16 max-w-8xl">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="md:w-1/2">
          <h2 className="text-3xl sm:text-4xl font-bold text-secondary text-center md:text-left">
            Discover Our Programs
          </h2>
        </div>
        <div className="md:w-1/2">
          <p className="text-light text-sm sm:text-base text-center md:text-left">
            Our programs are built around <span className="italic">ustawi kamili</span> —
            holistic well-being that goes beyond disease to strengthen
            individuals, families, and communities across Tanzania.
          </p>
        </div>
      </div>

      {/* Program Cards */}
      <div className="mt-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {objectives.map((item, idx) => (
            <ProgramCard
              key={idx}
              {...item}
              bgClass={
                idx === objectives.length - 1
                  ? "bg-primary bg-opacity-90 text-gray-100"
                  : "bg-tertiary bg-opacity-10"
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}
